import Background from "./Background";
import "./Books.css";
import Book from "../assets/book.webp";
import BookBackground from "../assets/book_background.webp";
import { ReactComponent as Arrow } from "../assets/arrow.svg";
import { useEffect, useState } from "react";
import HTMLFlipBook from "react-pageflip";
import { useIsMobile } from "../hooks/useIsMobile";
import { useAuthContext } from "../firebase/AuthContext";
import { firestore } from "../firebase/firebaseConfig";
import {
  setDoc,
  doc,
  onSnapshot,
  updateDoc,
  increment,
  deleteDoc,
  startAfter,
  query,
  collection,
  where,
  limit,
  getDocs,
  orderBy,
  arrayUnion,
  arrayRemove,
} from "firebase/firestore";
import {
  MedievalBackground,
  MedievalIntroduction,
} from "../scenarios/MedievalScenario";
import languages from "../assets/languages.json";
import { ReactComponent as Logo } from "../assets/Logo.svg";
import { ReactComponent as Garbage } from "../assets/garbage.svg";
import { ReactComponent as Copy } from "../assets/copy.svg";
import { ReactComponent as Heart } from "../assets/Heart.svg";
import { useNavigate } from "react-router-dom";

function Books() {
  const [bookOpened, setBookOpened] = useState(false);
  const [currentBook, setCurrentBook] = useState(null);
  const [bookCover, setBookCover] = useState(null);
  const [scenarioIntroduction, setScenarioIntroduction] = useState("");
  const [chooseTitle, setChooseTitle] = useState(false);
  const [title, setTitle] = useState("");
  const [notEnoughTokens, setNotEnoughTokens] = useState(false);
  const [tooManyPages, setTooManyPages] = useState(false);
  const [copied, setCopied] = useState(false);
  const [onlineMode, setOnlineMode] = useState(false);
  const [deleteBookDialog, setDeleteBookDialog] = useState(false);
  const [bookIndex, setBookIndex] = useState(0);
  const [onlineBooksLoading, setOnlineBooksLoading] = useState(false);
  const [filterLanguage, setFilterLanguage] = useState(0);
  const [filterLanguageOpened, setFilterLanguageOpened] = useState(false);
  const {
    user,
    userData,
    userBooks,
    setUserBooks,
    userLastBookDoc,
    setUserLastBookDoc,
    onlineBooks,
    setOnlineBooks,
    onlineLastBookDoc,
    setOnlineLastBookDoc,
    userBookBeingGenerated,
    setUserBookBeingGenerated,
    userNewBooks,
    setUserNewBooks,
    userBookTokens,
    setUserBookTokens,
    userLikedBooks,
    setUserLikedBooks,
    userLanguage,
  } = useAuthContext();
  const isMobile = useIsMobile();
  const navigate = useNavigate();

  const texts = {
    de: {
      generateBook: "Buch erstellen",
      noTokensLeft: "Keine Tokens übrig",
      tooManyPages: "Zu viele Seiten",
      generating: "wird erstellt",
      chooseTitle: "Wähle einen Titel",
      generate: "Erstellen",
      newBooksAvailable: "Neue Bücher verfügbar - Seite aktualisieren!",
      writeBookTitle: "Schreibe einen Buchtitel...",
      pages: "Seiten. max. 120!",
      copied: "Kopiert!",
      yourBooks: "Deine Bücher",
      onlineBooks: "Online Bücher",
      soonAvailable: "Bald verfügbar",
      validateBookDeletion:
        "Bist du dir sicher, dass du das Buch löschen willst? Der Token wird nicht rückerstattet!",
      yes: "Ja",
      no: "Nein",
    },
    en: {
      generateBook: "Generate Book",
      noTokensLeft: "No Tokens Left",
      tooManyPages: "too many pages",
      generating: "generating",
      chooseTitle: "Choose a Title",
      generate: "Generate",
      newBooksAvailable: "New Books available - Refresh the page!",
      writeBookTitle: "Write a title for your book...",
      pages: "pages. max. 120!",
      copied: "Copied!",
      yourBooks: "your books",
      onlineBooks: "online books",
      soonAvailable: "soon available",
      validateBookDeletion:
        "Are you sure you want to delete the book? The token will not be refunded!",
      yes: "Yes",
      no: "No",
    },
  };

  useEffect(() => {
    if (currentBook) {
      switch (currentBook.scenario) {
        case "Medieval":
          setBookCover(MedievalBackground());
          setScenarioIntroduction(
            MedievalIntroduction(
              languages.languages[currentBook.languageIndex].short
            )
          );
          break;
        default:
          break;
      }
    }
  }, [currentBook]);

  const generateBook = async () => {
    setChooseTitle(false);
    setUserBookBeingGenerated(true);
    await setDoc(doc(firestore, "bookSessions", user.uid), {
      userId: user.uid,
      name: userData.name,
      title: title,
    });

    await updateDoc(doc(firestore, "users", user.uid), {
      bookTokens: increment(-1),
    });

    setUserBookTokens(userBookTokens - 1);

    const bookRef = doc(firestore, "bookSessions", user.uid);

    onSnapshot(bookRef, (docSnapshot) => {
      if (!docSnapshot.exists()) {
        setUserBookBeingGenerated(false);
        setUserNewBooks(true);
      }
    });
  };

  const deleteBook = async () => {
    const bookRef = doc(firestore, "books", currentBook.id);
    deleteDoc(bookRef);
    setUserBooks(userBooks.filter((item) => item.id !== currentBook.id));
    setCurrentBook(null);
    setBookOpened(false);
  };

  const copyLink = async () => {
    const bookLink = `https://gliatech.net/sharedBook?id=${currentBook.id}`;

    await navigator.clipboard.writeText(bookLink);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const closeBook = () => {
    setBookOpened(false);
    setCurrentBook(null);
  };

  const fetchUserBooks = async () => {
    let booksRef = null;

    if (userLastBookDoc) {
      booksRef = query(
        collection(firestore, "books"),
        where("userId", "==", user.uid),

        orderBy("likes", "desc"),
        orderBy("createdAt", "desc"),
        limit(10),
        startAfter(userLastBookDoc)
      );
    } else {
      booksRef = query(
        collection(firestore, "books"),
        where("userId", "==", user.uid),

        orderBy("likes", "desc"),
        orderBy("createdAt", "desc"),
        limit(10)
      );
    }

    const booksSnapshot = await getDocs(booksRef);

    if (booksSnapshot.empty) {
      setUserLastBookDoc(-1);
      return;
    }

    setUserLastBookDoc(booksSnapshot.docs[booksSnapshot.docs.length - 1]);

    const bookList = [];

    booksSnapshot.forEach((doc) => {
      bookList.push({
        id: doc.id,
        author: doc.data()["author"],
        title: doc.data()["title"],
        content: doc.data()["book"],
        scenario: doc.data()["scenario"],
        likes: doc.data()["likes"],
        languageIndex: doc.data()["languageIndex"],
      });
    });

    setUserBooks([...userBooks, ...bookList]);

    if (booksSnapshot.docs.length < 10) setUserLastBookDoc(-1);
  };

  const fetchOnlineBooks = async () => {
    if (onlineBooks.length == 0) setOnlineBooksLoading(true);
    let booksRef = null;

    if (onlineLastBookDoc) {
      booksRef = query(
        collection(firestore, "books"),
        where("userId", "!=", user ? user.uid : ""),
        where("languageIndex", "==", filterLanguage),
        orderBy("likes", "desc"),
        orderBy("createdAt", "desc"),
        limit(10),
        startAfter(onlineLastBookDoc)
      );
    } else {
      booksRef = query(
        collection(firestore, "books"),
        where("userId", "!=", user ? user.uid : ""),
        where("languageIndex", "==", filterLanguage),
        orderBy("likes", "desc"),
        orderBy("createdAt", "desc"),
        limit(10)
      );
    }

    const booksSnapshot = await getDocs(booksRef);

    if (booksSnapshot.empty) {
      setOnlineLastBookDoc(-1);
      setOnlineBooksLoading(false);
      return;
    }

    setOnlineLastBookDoc(booksSnapshot.docs[booksSnapshot.docs.length - 1]);

    const bookList = [];

    booksSnapshot.forEach((doc) => {
      bookList.push({
        id: doc.id,
        author: doc.data()["author"],
        title: doc.data()["title"],
        content: doc.data()["book"],
        scenario: doc.data()["scenario"],
        likes: doc.data()["likes"],
        languageIndex: doc.data()["languageIndex"],
      });
    });

    setOnlineBooks([...onlineBooks, ...bookList]);
    setOnlineBooksLoading(false);

    if (booksSnapshot.docs.length < 10) setOnlineLastBookDoc(-1);
  };

  const changeOnlineBooksLanguage = async (selectedIndex) => {
    setOnlineBooksLoading(true);

    const booksRef = query(
      collection(firestore, "books"),
      where("userId", "!=", user ? user.uid : ""),
      where("languageIndex", "==", selectedIndex),
      orderBy("likes", "desc"),
      orderBy("createdAt", "desc"),
      limit(10)
    );

    const booksSnapshot = await getDocs(booksRef);

    if (booksSnapshot.empty) {
      setOnlineBooks([]);
      setOnlineLastBookDoc(-1);
      setOnlineBooksLoading(false);
      return;
    }

    setOnlineLastBookDoc(booksSnapshot.docs[booksSnapshot.docs.length - 1]);

    const bookList = [];

    booksSnapshot.forEach((doc) => {
      bookList.push({
        id: doc.id,
        author: doc.data()["author"],
        title: doc.data()["title"],
        content: doc.data()["book"],
        scenario: doc.data()["scenario"],
        likes: doc.data()["likes"],
        languageIndex: doc.data()["languageIndex"],
      });
    });

    setOnlineBooks(bookList);
    setOnlineBooksLoading(false);

    if (booksSnapshot.docs.length < 10) setOnlineLastBookDoc(-1);
  };

  const likeBook = async () => {
    if (currentBook) {
      const bookRef = doc(firestore, "books", currentBook.id);
      const userRef = doc(firestore, "users", user.uid);

      if (!userLikedBooks.includes(currentBook.id)) {
        setUserLikedBooks([...userLikedBooks, currentBook.id]);

        setCurrentBook({
          ...currentBook,
          likes: currentBook.likes + 1,
        });

        await Promise.all([
          updateDoc(bookRef, {
            likes: increment(1),
          }),
          updateDoc(userRef, {
            likedBooks: arrayUnion(currentBook.id),
          }),
        ]);
      } else {
        setUserLikedBooks(
          userLikedBooks.filter((bookId) => bookId !== currentBook.id)
        );

        setCurrentBook({
          ...currentBook,
          likes: currentBook.likes - 1,
        });

        await Promise.all([
          updateDoc(bookRef, {
            likes: increment(-1),
          }),
          updateDoc(userRef, {
            likedBooks: arrayRemove(currentBook.id),
          }),
        ]);
      }
    }
  };

  return (
    <>
      <Background></Background>
      <div className="books">
        <div
          className="select-your-books"
          style={{
            backgroundColor: !onlineMode && "rgba(204, 204, 204, 0.74)",
          }}
          onClick={() => {
            setBookIndex(0);
            setOnlineMode(false);
          }}
        >
          {texts[userLanguage]["yourBooks"]}
        </div>
        <div
          className="select-online-books"
          style={{
            flexDirection: "column",
            backgroundColor: onlineMode && "rgba(204, 204, 204, 0.74)",
          }}
          onClick={() => {
            if (onlineLastBookDoc != -1) {
              fetchOnlineBooks();
            }
            setBookIndex(0);
            setOnlineMode(true);
          }}
        >
          {" "}
          {texts[userLanguage]["onlineBooks"]}
        </div>
        <div className="book-tokens">
          {userBookTokens ?? 0}
          <img src={Book} style={{ height: "40px" }}></img>
          <div className="buy-tokens" onClick={() => navigate("/bookTokens")}>
            +
          </div>
        </div>
        {copied && (
          <div className="copied">{texts[userLanguage]["copied"]}</div>
        )}
        {onlineMode && !bookOpened && (
          <div className="filter">
            <div
              className="language"
              onClick={() => setFilterLanguageOpened(true)}
            >
              {languages.languages[filterLanguage].name}
            </div>
          </div>
        )}
        {filterLanguageOpened && (
          <>
            <div
              className="darken"
              onClick={() => setFilterLanguageOpened(false)}
            ></div>
            <div className="lang-list">
              {languages.languages.map((item, index) => (
                <div
                  key={index}
                  style={{
                    backgroundColor: filterLanguage === index && "white",
                    color: filterLanguage === index && "purple",
                  }}
                  onClick={() => {
                    setFilterLanguage(index);
                    changeOnlineBooksLanguage(index);
                    setFilterLanguageOpened(false);
                  }}
                >
                  {item.name}
                </div>
              ))}
            </div>
          </>
        )}
        {bookOpened && currentBook && (
          <>
            <div className="book-opened-darken"></div>
            {!isMobile ? (
              <div className="book-table">
                <HTMLFlipBook
                  width={isMobile ? 300 : window.innerHeight <= 850 ? 500 : 700}
                  height={
                    isMobile ? 400 : window.innerHeight <= 850 ? 600 : 800
                  }
                  className="book"
                  showCover={true}
                >
                  <div>
                    <div
                      style={{
                        position: "absolute",
                        backgroundImage: `url(${bookCover})`,
                        height: "100%",
                        width: "100%",
                        position: "absolute",
                        backgroundPosition: "center",
                        backgroundSize: "cover",
                        alignItems: "center",
                        display: "flex",
                        flexDirection: "column",
                        boxShadow: "inset 15px 0px 20px 3px black",
                      }}
                    >
                      <p
                        style={{
                          marginTop: "100px",
                          textAlign: "center",
                          fontSize: "26px",
                          color: "white",
                          textShadow: "0px 0px 5px black",
                          textDecoration: "underline",
                        }}
                      >
                        {currentBook.author}
                      </p>
                      <p
                        style={{
                          marginTop: isMobile ? "50px" : "150px",
                          textAlign: "center",
                          fontSize: isMobile ? "40px" : "50px",
                          width: "80%",
                          color: "white",
                          textShadow: "0px 0px 5px black",
                          wordBreak: "break-word",
                          fontWeight: "bold",
                        }}
                      >
                        {currentBook.title}
                      </p>
                    </div>
                  </div>
                  {currentBook.content.map((content, index) => (
                    <div key={index}>
                      <div
                        style={{
                          backgroundImage: `url(${BookBackground})`,
                          backgroundPosition: "center",
                          backgroundRepeat: "no-repeat",
                          backgroundSize: "cover",
                          position: "absolute",
                          height: "100%",
                          width: "100%",
                          fontSize: isMobile
                            ? "12px"
                            : window.innerHeight <= 850
                            ? "14px"
                            : "20px",
                          fontFamily: "'Garamond', serif",
                          color: "#704214",
                          textShadow: "1px 1px 1px rgba(0, 0, 0, 0.3)",
                          display: "flex",
                          justifyContent: "end",
                          alignItems: "center",
                          border: "2px solid black",
                          boxShadow: "0px 0px 25px 5px black",
                          userSelect: "none",
                          transform: index % 2 !== 0 && "scaleX(-1)",
                          borderRadius: "10px",
                          zIndex: "99",
                        }}
                      >
                        <p
                          style={{
                            transform: index % 2 !== 0 && "scaleX(-1)",
                            width: isMobile
                              ? "200px"
                              : window.innerHeight <= 850
                              ? "340px"
                              : "470px",
                            height: isMobile
                              ? "260px"
                              : window.innerHeight <= 850
                              ? "450px"
                              : "550px",
                            overflow: "scroll",
                            padding: "0px 10px 0px 15px",
                            marginTop: isMobile ? "15px" : "80px",
                            lineHeight: isMobile
                              ? "16px"
                              : window.innerHeight <= 850
                              ? "21px"
                              : "24px",
                          }}
                        >
                          {content}
                        </p>
                        <p
                          style={{
                            transform: index % 2 !== 0 && "scaleX(-1)",
                            position: "absolute",
                            bottom: isMobile ? 10 : 40,
                            textAlign: "center",
                            width: "80%",
                            fontSize: "20px",
                          }}
                        >
                          {index + 1}
                        </p>
                      </div>
                    </div>
                  ))}
                  {currentBook.content.length % 2 !== 0 ? (
                    <div>
                      <div
                        style={{
                          backgroundImage: `url(${BookBackground})`,
                          backgroundPosition: "center",
                          backgroundRepeat: "no-repeat",
                          backgroundSize: "cover",
                          position: "absolute",
                          height: "100%",
                          width: "100%",
                          fontSize: "18px",
                          color: "white",
                          border: "2px solid black",
                          boxShadow: "0px 0px 25px 5px black",
                          userSelect: "none",
                          transform: "scaleX(-1)",
                        }}
                      >
                        <p
                          style={{
                            transform: "scaleX(-1)",
                            position: "absolute",
                            bottom: 0,
                            left: 50,
                          }}
                        >
                          {currentBook.content.length + 1}
                        </p>
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}
                  <div>
                    <div
                      style={{
                        backgroundImage: `url(${bookCover})`,
                        height: "100%",
                        width: "100%",
                        position: "absolute",
                        backgroundPosition: "center",
                        backgroundSize: "cover",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        boxShadow: "inset -15px 0px 20px 3px black",
                      }}
                    >
                      <p
                        style={{
                          width: "60%",
                          fontSize: isMobile ? "12px" : "20px",
                          color: "white",
                          textShadow: "0px 0px 5px black",
                        }}
                      >
                        {scenarioIntroduction}
                      </p>
                    </div>
                  </div>
                </HTMLFlipBook>
              </div>
            ) : (
              <div className="book-table">
                <div
                  style={{
                    height: "100%",
                    width: "100%",
                    display: "flex",
                    overflowX: "scroll",
                    overflowY: "hidden",
                  }}
                >
                  <div
                    style={{
                      backgroundImage: `url(${bookCover})`,
                      flex: "0 0 100%",
                      backgroundPosition: "center",
                      backgroundSize: "cover",
                      alignItems: "center",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <p
                      style={{
                        marginTop: "100px",
                        textAlign: "center",
                        fontSize: "26px",
                        color: "white",
                        textShadow: "0px 0px 5px black",
                        textDecoration: "underline",
                      }}
                    >
                      {currentBook.author}
                    </p>
                    <p
                      style={{
                        marginTop: "50px",
                        textAlign: "center",
                        fontSize: "40px",
                        width: "80%",
                        color: "white",
                        textShadow: "0px 0px 5px black",
                        wordBreak: "break-word",
                        fontWeight: "bold",
                      }}
                    >
                      {currentBook.title}
                    </p>
                  </div>
                  {currentBook.content.map((content, index) => (
                    <div
                      key={index}
                      style={{
                        backgroundColor: "rgba(255,230,155,1)",
                        flex: "0 0 100%",
                        fontSize: "12px",
                        fontFamily: "'Garamond', serif",
                        color: "#704214",
                        textShadow: "1px 1px 1px rgba(0, 0, 0, 0.3)",
                        display: "flex",
                        justifyContent: "end",
                        alignItems: "center",
                        border: "2px solid black",
                        userSelect: "none",
                        borderRadius: "10px",
                      }}
                    >
                      <p
                        style={{
                          width: "100%",
                          height: "90%",
                          overflow: "scroll",
                          padding: "0px 10px 0px 15px",
                          lineHeight: "20px",
                        }}
                      >
                        {content}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            )}

            <div className="book-actions">
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    color: "white",
                    userSelect: "none",
                    textShadow: "0px 0px 5px purple",
                  }}
                >
                  {currentBook.likes}
                </span>
                {onlineMode ? (
                  <Heart
                    className="button"
                    style={{
                      color: userLikedBooks.includes(currentBook.id)
                        ? "rgba(255,255,255,1)"
                        : "rgba(255,255,255,0)",
                      height: isMobile ? "50px" : "70px",
                      transition: "all 0.5s",
                    }}
                    onClick={() => {
                      if (user) likeBook();
                    }}
                  ></Heart>
                ) : (
                  <Heart
                    className="button"
                    style={{
                      color: "rgba(255,255,255,1)",
                      height: isMobile ? "50px" : "70px",
                    }}
                  ></Heart>
                )}
              </div>

              {!isMobile ? (
                <div
                  className="button"
                  onClick={() => copyLink()}
                  style={{
                    width: "360px",
                    height: "60px",
                    border: "2px solid white",
                    borderRadius: "14px",
                    backgroundColor: "rgba(0,0,0,0.3)",
                    padding: "0px 0px 0px 10px",
                  }}
                >
                  https://gliatech.net/sharedBook?id=${currentBook.id}
                  <Copy
                    style={{
                      height: "50px",
                      width: "100px",
                    }}
                  ></Copy>
                </div>
              ) : (
                <div className="button" onClick={() => copyLink()}>
                  <Copy
                    style={{
                      height: "50px",
                    }}
                  ></Copy>
                </div>
              )}
              {!onlineMode && (
                <Garbage
                  className="button"
                  onClick={() => setDeleteBookDialog(true)}
                ></Garbage>
              )}
            </div>
            <div className="close-button" onClick={() => closeBook()}>
              X
            </div>
            {deleteBookDialog && (
              <div className="delete-book">
                <div className="darken"></div>
                <div className="container">
                  <p>{texts[userLanguage]["validateBookDeletion"]}</p>
                  <div className="buttons">
                    <div className="button" onClick={() => deleteBook()}>
                      {texts[userLanguage]["yes"]}
                    </div>
                    <div
                      className="button"
                      onClick={() => setDeleteBookDialog(false)}
                    >
                      {texts[userLanguage]["no"]}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </>
        )}
        {!onlineMode ? (
          !bookOpened && (
            <div className="book-items">
              <Arrow
                className="arrow"
                style={{
                  transform: "scaleX(-1)",
                  marginRight: "15px",
                  display: bookIndex == 0 && "none",
                }}
                onClick={() => {
                  if (bookIndex > 0) setBookIndex(bookIndex - 1);
                }}
              ></Arrow>
              {userBooks
                .slice(bookIndex * 5, bookIndex * 5 + 5)
                .map((item, index) => (
                  <div
                    key={index}
                    onClick={() => {
                      setCurrentBook(item);
                      setBookOpened(true);
                    }}
                    className="book-item"
                    style={{ marginTop: isMobile && index == 0 && "50%" }}
                  >
                    <div className="item-title">
                      <p>{item.title}</p>
                    </div>
                    <img src={Book}></img>
                  </div>
                ))}
              <Arrow
                className="arrow"
                style={{
                  right: "15%",
                  left: isMobile && "60%",
                  display: (bookIndex + 1) * 5 >= userBooks.length && "none",
                }}
                onClick={() => {
                  if ((bookIndex + 1) * 5 < userBooks.length) {
                    setBookIndex(bookIndex + 1);
                    if (userLastBookDoc != -1) {
                      fetchUserBooks();
                    }
                  }
                }}
              ></Arrow>
            </div>
          )
        ) : !onlineBooksLoading ? (
          !bookOpened && (
            <div className="book-items">
              <Arrow
                className="arrow"
                style={{
                  transform: "scaleX(-1)",
                  marginRight: "15px",
                  display: bookIndex == 0 && "none",
                }}
                onClick={() => {
                  if (bookIndex > 0) setBookIndex(bookIndex - 1);
                }}
              ></Arrow>
              {onlineBooks
                .slice(bookIndex * 5, bookIndex * 5 + 5)
                .map((item, index) => (
                  <div
                    key={index}
                    onClick={() => {
                      setCurrentBook(item);
                      setBookOpened(true);
                    }}
                    className="book-item"
                    style={{ marginTop: isMobile && index == 0 && "50%" }}
                  >
                    <div className="item-title">
                      <span
                        style={{
                          textDecoration: "underline",
                          fontSize: "19px",
                        }}
                      >
                        {item.author}
                      </span>
                      <p style={{ marginTop: "10px" }}>{item.title}</p>
                    </div>
                    <img src={Book}></img>
                  </div>
                ))}
              <Arrow
                className="arrow"
                style={{
                  right: "15%",
                  left: isMobile && "60%",
                  display: (bookIndex + 1) * 5 >= onlineBooks.length && "none",
                }}
                onClick={() => {
                  if ((bookIndex + 1) * 5 < onlineBooks.length) {
                    setBookIndex(bookIndex + 1);
                    if (onlineLastBookDoc != -1) {
                      fetchOnlineBooks();
                    }
                  }
                }}
              ></Arrow>
            </div>
          )
        ) : (
          <Logo
            style={{
              width: "10%",
              height: "5%",
              filter: "drop-shadow(0px 0px 10px black)",
              color: "white",
              animation: "rotate 2s linear infinite",
            }}
          ></Logo>
        )}
        {!bookOpened &&
          localStorage.getItem("scenario") &&
          !onlineMode &&
          (!userBookBeingGenerated ? (
            <div
              className="generate-book"
              onClick={() => {
                if (parseInt(localStorage.getItem("pages")) > 120) {
                  setTooManyPages(true);
                } else if (userBookTokens > 0) {
                  setChooseTitle(true);
                } else setNotEnoughTokens(true);
              }}
            >
              {texts[userLanguage]["generateBook"]}
              <span style={{ fontSize: isMobile ? "10px" : "15px" }}>
                ( {localStorage.getItem("pages")} {texts[userLanguage]["pages"]}{" "}
                )
              </span>
              <span
                style={{
                  fontSize: "20px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                -1 <img src={Book} style={{ height: "34px" }}></img>
              </span>
              {notEnoughTokens && (
                <span
                  style={{
                    fontSize: "15px",
                    color: "white",
                    textShadow: "0px 0px 7px red",
                  }}
                >
                  {texts[userLanguage]["noTokensLeft"]}!
                </span>
              )}
              {tooManyPages && (
                <span
                  style={{
                    fontSize: "15px",
                    color: "white",
                    textShadow: "0px 0px 7px red",
                  }}
                >
                  {texts[userLanguage]["tooManyPages"]}!
                </span>
              )}
            </div>
          ) : (
            <div className="generate-book">
              {texts[userLanguage]["generating"]}...
              <Logo
                style={{
                  width: "10%",
                  height: "5%",
                  filter: "drop-shadow(0px 0px 10px black)",
                  color: "white",
                  animation: "rotate 2s linear infinite",
                }}
              ></Logo>
            </div>
          ))}
        {chooseTitle && (
          <div className="choose-title">
            <div
              className="darken"
              onClick={() => {
                setChooseTitle(false);
              }}
            ></div>
            <div className="container">
              <p>{texts[userLanguage]["chooseTitle"]}!</p>
              <textarea
                maxLength={55}
                onChange={(e) => setTitle(e.currentTarget.value)}
                placeholder={texts[userLanguage]["writeBookTitle"]}
              ></textarea>
              <div
                className="buttons"
                onClick={() => {
                  if (title) generateBook();
                }}
              >
                {texts[userLanguage]["generate"]}
              </div>
            </div>
          </div>
        )}
        {userNewBooks && !bookOpened && (
          <div
            className="new-books-available"
            onClick={() => window.location.reload()}
          >
            {texts[userLanguage]["newBooksAvailable"]}
          </div>
        )}
      </div>
    </>
  );
}

export default Books;
